import { WebLoginSchema } from './webLoginSchema';

export const initialState: WebLoginSchema = {
  form: {
    type: 'login',
  },
};
